export default "__VITE_ASSET__Bd16sHFM__"